let products_on_page = $('.products-on-page');
let next_url = products_on_page.data('next-url');
let loadMoreBtn = $('.load-more-btn');
let loadMoreSpinner = $('.load-more-spinner');
let gridItems = $('.products-on-page li.grid__item');
let gridSize = gridItems.length;
let totalGridSize = gridItems.length;
let  spanElement = $('.displayed-products');
let  spanElement2 = $('.total-items');
   // console.log('Number of li elements with class "grid__item":',gridSize );

let next_url_c = $('.products-on-page').data('next-url');
let gridItems_c = $('.products-on-page li.grid__item');
let gridSize_c = 0;
let final_gridSize_c = 0;
function loadmoreBtn(state){
   if(state=="open"){
      document.querySelector('.load-more-btn').style.display = 'block';
   }else{
      document.querySelector('.load-more-btn').style.display = 'none';
   } 
}

function loadmoreSpn(state){
   if(state=="open"){
      document.querySelector('.load-more-spinner').style.display = 'block';
   }else{
      document.querySelector('.load-more-spinner').style.display = 'none';
   
   } }

function updateProdDisplayed() {
  if (window.location.href.includes('filter')) {
        let  spanElement = document.querySelector('.displayed-products');
        let gridItems = document.querySelectorAll('.products-on-page li.grid__item');
        let gridSize = gridItems.length;
        spanElement.textContent = gridSize;
        spanElement.setAttribute('total-displayed', gridSize);
  }
  
}



function loadMoreProducts(){
     loadMoreSpinner.show();
     loadMoreBtn.hide();
     $('.load-more-btn').hide(); 
     $('.load-more-spinner').show();

       products_on_page = $('.products-on-page');
       next_url = $('#product-grid').data('next-url');
       
       if (!next_url) {
         console.log('Load More: No next URL found, stopping.');
         $('.load-more-spinner').hide();
         return; 
       }

       console.log('Load More: Fetching ', next_url);

       $.ajax({
            url:next_url,
            type:'GET',
            dataType:'html',
            beforeSend:function(){
              // Actions moved before AJAX call
            }
          }).done(function(next_page){
             let new_product_items = $(next_page).find('#product-grid li.grid__item');
             
             if (new_product_items.length > 0) {
                 console.log('Load More: Appending', new_product_items.length, 'new products.');
                 $('#product-grid').append(new_product_items);
             } else {
                 console.log('Load More: No new product items found on the fetched page.');
             }

             let new_url = $(next_page).find('#product-grid').data('next-url');
             console.log('Load More: Next page URL from response:', new_url);

             $('#product-grid').data('next-url', new_url);
             $('#product-grid').attr('data-next-url', new_url);

             $('.load-more-spinner').hide();
             
             if(new_url){
                console.log('Load More: There is another page, showing button.');
                $('.load-more-btn').show();
             } else {
                console.log('Load More: Last page loaded, button remains hidden.');
                $('.load-more-btn').hide();
             }
             
             updateDisplayCounts(); 

             setTimeout(() => {
               if (typeof carouselifyCollectionNew === 'function') {
                 carouselifyCollectionNew(); 
               }
             }, 500);
            
          }).fail(function(jqXHR, textStatus, errorThrown) {
             console.error('Load More AJAX failed:', textStatus, errorThrown);
             $('.load-more-spinner').hide();
             $('.load-more-btn').show();
          });
}

function updateDisplayCounts() {
    const displayedProductsSpan = document.querySelector('.progress-info .displayed-products');
    const totalItemsSpan = document.querySelector('.progress-info .total-items');
    const totalCollectionInput = document.getElementById('total-collection-count');

    if (displayedProductsSpan && totalItemsSpan && totalCollectionInput) {
      const currently_displayed = $('#product-grid li.grid__item').length;
      const total_items = parseInt(totalCollectionInput.value, 10);

      displayedProductsSpan.textContent = currently_displayed;
      totalItemsSpan.textContent = total_items;

      console.log('Counts Updated: Showing', currently_displayed, 'of', total_items);
    } else {
       console.warn('updateDisplayCounts: Missing elements needed for update (displayed, total, or hidden input).');
    }
}

function carouselifyCollectionNew() {
    // console.log("executing carouselifyCollection new.... ");
    //removeStyles();
    // Carousel init
    const collection_carousels = document.querySelectorAll('.custom.carouselOfImages');

    collection_carousels.forEach(carousel => {
        // Check if the carousel already has a Flickity instance
        if (carousel.flickity) {
            carousel.flickity('destroy'); // Destroy existing Flickity instance
        }

        // Reinitialize Flickity
        new Flickity(carousel, {
            // options go here
            cellAlign: 'left',
            contain: true,
            friction: 0.2,
            initialIndex: 0,
            pageDots: true,
            lazyLoad: false,
            wrapAround: true,
            cellSelector: '.collection-product__anchor',
            prevNextButtons: false,
        });
    });

    var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");

  // Delay hiding elements to allow Tolstoy to add content
  setTimeout(function() {
    tolstoyTiles.forEach(function (tile) {
      // Check if the tile still has no child nodes after the delay
      if (!tile.hasChildNodes()) {
        tile.style.display = "none";
      }
    });
  }, 3000)

    // console.log("carouselifyCollection executed new");
}

$(document).ready(function() {
    console.log('Load More Script: Document ready.');
    
    // Check if pagination is needed on initial load
    const initialNextUrl = $('#product-grid').data('next-url');
    const loadMoreWrapper = $('.loadmore-wrapper');
    
    if (initialNextUrl && loadMoreWrapper.length) {
        console.log('Load More Script: Next page detected, ensuring wrapper is visible.');
        loadMoreWrapper.show(); // Use jQuery show() to handle display style
        // If button hidden by default CSS, ensure it's shown too initially
        // Note: loadMoreProducts() hides it immediately on click anyway.
        $('.load-more-btn', loadMoreWrapper).show(); 
    } else if (loadMoreWrapper.length) {
        console.log('Load More Script: No next page detected, ensuring wrapper is hidden.');
        loadMoreWrapper.hide(); // Hide wrapper if no next URL
    }

    // Attach the click handler to the button
    $('body').on('click', '.load-more-btn', function(e) {
        e.preventDefault(); // Prevent default button behavior
        console.log('Load More Script: Button clicked!');
        loadMoreProducts(); // Call the AJAX function
    });

    // Initial count update on page load
    updateDisplayCounts(); 
});

